import React from 'react';
import TwoColumnRow from '../../../../tc-ui/two-column-row';
import Select from 'react-select';
import { FlatButton } from 'material-ui';
import { extraNameAndCode } from '../../../../../utils/contracting-preset-names-codes';
import StepperActions from '../../../generic-components/stepper-actions';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import AccomRateForm from '../../../generic-components/rate-forms/accom-rates-form.jsx';
import NonAccomRateForm from '../../../generic-components/rate-forms/non-accommo-rates-form-templates/non-accom-rates-form.jsx';
import { isEmpty, any, or } from 'ramda';
import { getIn } from '../../../../../utils/functional';

export const checkIfShouldDisable = (data, extraRates, templateType = 'Non-Accommodation') => {
  const checkRateAmount = () => {
    if (templateType === 'Non-Accommodation') {
      const standardIsEmpty = isEmpty(getIn(['nonAccomStandard', 'nett'], extraRates), getIn(['nonAccomStandard', 'retail'], extraRates));
      const multiDayTourIsEmpty = !any(value => value)([
        extraRates.baseRate,
        or(extraRates.rateType === 'includeCommission' && extraRates.retailRate, extraRates.rateType === 'nett'),
        extraRates.singleSupplement,
        extraRates.maxAdults,
      ]);
      const transfersOrPriceBreakIsEmpty = (() => {
        const checkForSingleDetail = detail => {
          return detail.maxAdultsPlusChild && detail.baseRate && (extraRates.rateType === 'includeCommission' ? detail.retailRate : true);
        };
        const filteredArray = (extraRates.transfersOrPriceBreak || []).filter(checkForSingleDetail);
        return !Boolean(filteredArray.length);
      })();
      return !standardIsEmpty || !multiDayTourIsEmpty || !transfersOrPriceBreakIsEmpty;
    }
    if (templateType === 'Accommodation') {
      if (extraRates.rateType === 'nett') return Boolean(extraRates.baseRate && extraRates.additionalAdult && extraRates.additionalChild && extraRates.includedGuestsinBaseRate && extraRates.maxAdults && extraRates.maxAdultsChildren);
      if (extraRates.rateType === 'includeCommission') return Boolean(extraRates.retailRate && extraRates.additionalAdult && extraRates.additionalChild && extraRates.includedGuestsinBaseRate && extraRates.maxAdults && extraRates.maxAdultsChildren);
    }
  };
  return !Boolean(
    data.extraType &&
    extraRates.currency &&
    extraRates.taxInclusion &&
    (extraRates.taxInclusion === 'exempt' || extraRates.taxType) &&
    checkRateAmount()
  );
};
const OneStep = ({
  data,
  extraRates,
  onTextFieldChangeWithKeyPath,
  updateFieldForOfferRates,
  updateFieldWithKeyPathForOfferRates,
  goToStep,
  onRequestClose,
  updateFormData,
  calculateStandardNonAccomRatesTable,
}) => {
  const {
    extraType,
    extraCode,
    description,
  } = data;
  const shouldDisable = checkIfShouldDisable(data, extraRates);
  const extraNameSelectFields = Object.keys(extraNameAndCode).map(nameAndCode => ({ label: nameAndCode, value: nameAndCode }));
  const fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
  const leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px', fontFamily };
  const rightColumnStyle = { width: '70%', textAlign: 'left', paddingRight: '80px', fontFamily };
  const continueFunc = calculateStandardNonAccomRatesTable;

  return (
    <div>
      <div style={{ padding: '24px 0 24px 12%' }}>
        <TwoColumnRow
          outerContainerStyle={{ marginBottom: '12px', overflow: 'inherit' }}
          leftColumnStyle={leftColumnStyle}
          rightColumnStyle={rightColumnStyle}
          leftColumnContent={
            <div>
              Extra type
              <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
                * Required
              </div>
            </div>
          }
          rightColumnContent={
              <div style={{ width: '100%', display: 'inline-block' }}>
                <Select
                  name="extraType"
                  options={extraNameSelectFields}
                  value={extraType}
                  onChange={({ value }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'extraType'], value })}
                  placeholder="Please select extra type"
                  clearable={false}
                  scrollMenuIntoView={false}
                />
              </div>
          }
        />
        <TwoColumnRow
          outerContainerStyle={{ marginBottom: '12px', clear: 'both' }}
          leftColumnStyle={leftColumnStyle}
          rightColumnStyle={rightColumnStyle}
          leftColumnContent={<div style={{ position: 'relative', top: '20px' }}>Extra code</div>}
          rightColumnContent={
            <TypeControlledTextField
              id="extra code"
              style={{ width: '100%' }}
              hintText={extraNameAndCode[extraType]}
              value={extraCode}
              onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'extraCode'], value })}
            />
          }
        />
        <TwoColumnRow
          outerContainerStyle={{ marginBottom: '24px' }}
          leftColumnStyle={leftColumnStyle}
          rightColumnStyle={rightColumnStyle}
          leftColumnContent={<div style={{ position: 'relative', top: '20px' }}>Description</div>}
          rightColumnContent={
            <div style={{ width: '100%' }}>
              <textarea
                id="description"
                rows={8}
                defaultValue={description}
                onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'description'], value })}
              />
            </div>
          }
        />
        {
          extraType ? <NonAccomRateForm
            definedRateTemplate="standard"
            {...extraRates}
            showTaxCurrency
            updateFieldWithKeyPath={updateFieldWithKeyPathForOfferRates}
            updateFieldValue={updateFieldForOfferRates}
            updateFormData={updateFormData}
          /> : undefined
        }
      </div>

      <br />
      <StepperActions
        style={{ clear: 'both' }}
        rightButtons={
          <div style={{ marginRight: '66px' }}>
            <FlatButton
              label="Generate Rate Table"
              hoverColor="none"
              labelStyle={{ fontWeight: '600' }}
              onTouchTap={() => {
                continueFunc();
                goToStep({ stepperWizardName: 'addExtraStepper', componentIndex: 1 });
              }}
              secondary
              disabled={shouldDisable}
            />
          </div>
        }
      />
    </div>
  );
};

export default OneStep;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/extras/1-step-add-extra.jsx